import classNames from 'classnames';

import Typography from '@components/atoms/Typography';
import ContentBox from '@components/atoms/ContentBox';
import { FormattedMessage } from 'utils/intl';

import messages from './OurWay.messages';
import classes from './OurWay.module.scss';

type Props = {
  year: string;
  className?: string;
};

const OurWay = ({ year, className }: Props): JSX.Element => (
  <div className={classNames(className, classes.wrapper)}>
    <div className={classes.year}>{year}</div>
    <div className={classes.top}>
      <Typography variant="h1" renderAs="div" weight="400">
        <FormattedMessage {...messages.start} />
      </Typography>
      <Typography variant="h1" renderAs="div" className={classes.huge}>
        <FormattedMessage {...messages.way} />
      </Typography>
    </div>
    <div className={classes.line} />
    <ContentBox variant="main" wide>
      <div className={classes.top}>
        <Typography className={classes.contentBoxFirstHeader} variant="h1" renderAs="div">
          <FormattedMessage {...messages.employees} />
        </Typography>
      </div>
    </ContentBox>
  </div>
);

export default OurWay;
